import React from 'react';
import { bool, string } from 'prop-types';

import blueInfoIcon from '../../../../assets/icon-info-blue.svg';
import whiteInfoIcon from '../../../../assets/icon-info-white.svg';
import Tooltip from '../tooltip/tooltip';
import { IconContainer } from './info-tooltip-button.style';
import ImageIcon from '../image-icon';

/**
 * InfoTooltipButton component
 * @param {object} params - Object containing props for this component
 * @param {string} text - Text to show in the tooltip
 * @param {boolean} isPrimary - Specifies if the primary color should be used
 * @param {string} position - Specifies where to show the tooltip
 * @return {element}
 */
const InfoTooltipButton = ({ text, isPrimary, position }) => (
  <Tooltip content={text} position={position} delay={0.2}>
    <IconContainer>
      <ImageIcon
        src={isPrimary ? whiteInfoIcon : blueInfoIcon}
        altString="Info Icon"
        width={20}
        height={20}
      />
    </IconContainer>
  </Tooltip>
);

InfoTooltipButton.propTypes = {
  text: string.isRequired,
  isPrimary: bool,
  position: string,
};

InfoTooltipButton.defaultProps = {
  isPrimary: false,
  position: 'bottom-left',
};

export default InfoTooltipButton;
